/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 13:58:40
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-06 17:43:49
 * @Description: file content
 */

export default {
  appid: "",
  protocol: "",
  domain: "",
  openid: "",// 私有
  action: {
    getSignature: "/yq-auth/web/userAuth/getSignature",
    auth: "/yq-auth/web/userAuth/auth"
  }
}